<template>
  <v-card
    elevation="0">
    <v-card-title>
          Товары
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-card-title>
        <v-data-table
        :headers="headers"
        :loading="loading"
        :items="items"
        :search="search"
        :items-per-page="500"
        height=600
        light
        class="elevation-1"
        
      >

        <template v-slot:[`item.image`]="{ item }">
            <v-img :src="item.image" contain width="30" height="30" /> 
        </template>

        <template v-slot:[`item.currentPosition`]="{ item }">
          <v-chip
            :color="getPositionColor(item.currentPosition)"
            dark
          >
            {{ item.currentPosition }}
          </v-chip>
        </template>
        
        <template v-slot:[`item.abc`]="{ item }">
          <v-chip
            :color="getABCColor(item.abc)"
            dark
          >
            {{ item.abc }}
          </v-chip>
        </template>

        <template v-slot:[`item.model`]="{ item }">
            <a v-bind:href="item.url" target="_blank">
              <span class="d-inline-block text-truncate model-col">{{ item.model }}</span>
            </a>  
        </template>

        <template v-slot:[`item.firstPriceDifference`]="{ item }">
            {{ `${item.firstPriceDifference} ₸` }}
        </template>

        <template v-slot:[`item.secondPriceDifference`]="{ item }">
            {{ `${item.secondPriceDifference} ₸` }}
        </template>

        <template v-slot:[`item.exportPriceKaspi`]="{ item }">
            {{ `${item.exportPriceKaspi} ₸` }}
        </template>

        <template v-slot:[`item.popularity`]="{ item }">
            {{ getPopularityIndicator(item.popularity) }}
        </template>
        
        <template v-slot:[`item.currentDeliveryTerm`]="{ item }">
          <v-chip
            v-if="item.currentDeliveryTerm"
            :color="getDeliveryColor(item.currentDeliveryTerm)"
            dark
          >
            {{ item.currentDeliveryTerm || "—" }}
          </v-chip>
        </template>

        <template v-slot:[`item.firstSellerName`]="{ item }">
          <span
            :class="[item.currentPosition === 1 ? 'current-seller' : '']"
          >
            {{  item.firstSellerName }}
          </span>
        </template>

        <template v-slot:[`item.kaspiReviewCount`]="{ item }">
          <template v-if="item.kaspiReviewCount > 0">
            <span class="col-reviews-gold">★</span> 
            ({{  item.kaspiReviewCount }})
          </template>
          <template v-else>
            <span class="col-reviews-gray">★</span>
          </template>
        </template>
      </v-data-table>
  </v-card>
</template>

<script>

export default {
  props: {
    items: Array,
    loading: Boolean,
  },
  components: {
  },
  mixins: [],
  data() {
    return {
      search: '',
      headers: [
          { text: '', value: 'image' },
          { text: 'Рейтинг', value: 'kaspiReviewCount', },
          { text: 'SKU', value: 'sku', },
          { text: 'Позиция', value: 'currentPosition' },
          { text: 'Разница с #1', value: 'firstPriceDifference' },
          { text: 'Первый продавец', value: 'firstSellerName', width: 120 },
          { text: 'Ваша доставка', value: 'currentDeliveryTerm' },
          { text: 'Лучшая доставка', value: 'bestDeliveryTerm' },
          { text: 'Бренд', value: 'brand' },
          { text: 'Название', value: 'model' },
          { text: 'Город', value: 'city' },
          { text: 'Цена', value: 'exportPriceKaspi', width: 110 },
          { text: 'ABC', value: 'abc' },
        ],
    };
  },
  computed: {
  },
  methods: {
    getPositionColor (position) {
        if (position === 1) return 'green'
        else if (position === 2) return 'orange'
        else return 'red'
      },
    getABCColor (abc) {
        switch (abc) {
          case 'A': return 'green';
          case 'B': return 'orange';
          case 'C': return 'red';
        }
      },  
    getPopularityIndicator (popularity) {
        if (popularity >= 80) return '🔥🔥🔥🔥🔥'
        else if (popularity >= 60) return '🔥🔥🔥🔥'
        else if (popularity >= 40) return '🔥🔥🔥'
        else if (popularity >= 20) return '🔥🔥'
        else if (popularity > 0) return '🔥'
        else return ''
      },   
    getDeliveryColor (isBestDelivery) {
      return isBestDelivery ? 'green' : 'red';
    }, 
  },
};
</script>

<style scoped>

.model-col {
  max-width: 350px;
  color: black;
  text-decoration: underline;
}

.current-seller {
  font-weight: 500;
  color: green;
}

.col-reviews-gold {
  color: goldenrod;
}

.col-reviews-gray {
  color: gray;
}

</style>